import { render, staticRenderFns } from "./GP2Browser.vue?vue&type=template&id=4b1bf68f&scoped=true&"
import script from "./GP2Browser.vue?vue&type=script&lang=js&"
export * from "./GP2Browser.vue?vue&type=script&lang=js&"
import style0 from "./GP2Browser.vue?vue&type=style&index=0&id=4b1bf68f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1bf68f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1bf68f')) {
      api.createRecord('4b1bf68f', component.options)
    } else {
      api.reload('4b1bf68f', component.options)
    }
    module.hot.accept("./GP2Browser.vue?vue&type=template&id=4b1bf68f&scoped=true&", function () {
      api.rerender('4b1bf68f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/GP2Browser.vue"
export default component.exports